/**
 * The product name, deliberately not a translation key: it reads the same in every language and
 * a catalogue entry would only invite someone to "translate" it.
 */
export const APP_NAME = 'WP Lead'
